/**
 * Claim Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines claim-related routes.
 * ============================================================================
 */

import { lazy } from 'react';
import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';
import type { RouteGroup } from 'navigation/types';

const ClaimsPage = lazy(() => import('@/features/claims/ui/pages/claims-page'));
const ClaimDetailPage = lazy(() => import('@/features/claims/ui/pages/claim-detail-page'));
const ClaimCreatePage = lazy(() => import('@/features/claims/ui/pages/add-claim-page'));
const ClaimEditPage = lazy(() => import('@/features/claims/ui/pages/claim-detail-page'));

export const claimRoutes: RouteGroup = {
  name: 'claims',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.CLAIMS,
      component: ClaimsPage,
      meta: {
        title: 'claims:title',
        icon: 'ClipboardDocumentCheckIcon',
        showInNav: true,
        navOrder: 4,
      },
    },
    {
      path: ROUTE_PATHS.CLAIM_CREATE,
      component: ClaimCreatePage,
      permission: {
        allowedRoles: [
          USER_ROLES.SUPER_ADMIN,
          USER_ROLES.ADMIN,
          USER_ROLES.AGENT,
          USER_ROLES.CUSTOMER,
        ],
      },
      meta: {
        title: 'claims:create.title',
        parent: ROUTE_PATHS.CLAIMS,
      },
    },
    {
      path: ROUTE_PATHS.CLAIM_DETAIL,
      component: ClaimDetailPage,
      meta: {
        title: 'claims:detail.title',
        parent: ROUTE_PATHS.CLAIMS,
      },
    },
    {
      path: ROUTE_PATHS.CLAIM_EDIT,
      component: ClaimEditPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'claims:edit.title',
        parent: ROUTE_PATHS.CLAIM_DETAIL,
      },
    },
  ],
};
